import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyCu-zNbjeLsJZR3P9zdxLMbJh4KUGeaY5k',
  authDomain: 'juiceplanet-581f4.firebaseapp.com',
  projectId: 'juiceplanet-581f4',
  storageBucket: 'juiceplanet-581f4.firebasestorage.app',
  messagingSenderId: '757179172030',
  appId: '1:757179172030:web:ee04b351f561cdbe718aef',
  measurementId: 'G-QDERZNNH9Z',
};

const app = initializeApp(firebaseConfig);

let messaging = null;
try {
  messaging = getMessaging(app);
} catch (err) {
  console.warn('Firebase messaging not supported:', err);
}

// VAPID key from Firebase Console -> Cloud Messaging -> Web Push certificates
const VAPID_KEY = 'BJq4F4YDpA1y5OlLHeU_cQSrcIm5keKceUJ43wY7nQ4B0uPS3LNVoD8-C-6NzbCYxoJuRhESBdPakrOqTgS5418';

export const requestNotificationPermission = async () => {
  try {
    if (!messaging) return null;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.log('Notification permission denied');
      return null;
    }

    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    console.log('FCM Token:', token);
    return token;
  } catch (error) {
    console.error('Error getting FCM token:', error);
    return null;
  }
};

export const onForegroundMessage = (callback) => {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    console.log('Foreground message:', payload);
    callback(payload);
  });
};

export { messaging };
